/**
 * S46b — numbered action plan table with coloured impact and bold timing.
 * Shows up to COLLAPSE_AFTER rows, then "Show more" like data tables.
 */
import { el } from '../../core/dom.js';
import { COLLAPSE_AFTER, resolvedOf } from './shape.js';

/**
 * @param {object} block
 * @returns {HTMLElement}
 */
export function renderActionPlan(block) {
  const data = resolvedOf(block);
  const items = Array.isArray(data.items) ? data.items : [];
  let open = false;
  const body = el('tbody');
  const more = el('button', { type: 'button', class: 'chat-more' });
  more.addEventListener('click', () => {
    open = !open;
    paint();
  });

  function paint() {
    const limit = open ? items.length : Math.min(items.length, COLLAPSE_AFTER);
    body.replaceChildren(...items.map((item, index) => {
      const impact = item.impact || 'medium';
      const whenClass = item.urgent || item.when === 'today' || item.when === 'this_week'
        ? 'is-urgent'
        : null;
      return el('tr', { hidden: index >= limit || null },
        el('td', { class: 'chat-td is-num is-index' }, String(index + 1)),
        el('td', { class: 'chat-td is-wrap is-action' }, String(item.action || '')),
        el('td', { class: 'chat-td' }, String(item.ownerLabel || item.owner || '')),
        el('td', { class: 'chat-td' }, String(item.effortLabel || item.effort || '')),
        el('td', { class: `chat-td is-impact is-${impact}` }, String(item.impactLabel || impact)),
        el('td', { class: ['chat-td', whenClass].filter(Boolean).join(' ') },
          String(item.whenLabel || item.when || '')));
    }));
    const extra = Math.max(0, items.length - COLLAPSE_AFTER);
    setHidden(more, extra === 0);
    more.setAttribute('aria-expanded', open ? 'true' : 'false');
    more.textContent = open ? 'Show fewer rows' : `Show ${extra} more rows`;
  }

  function setHidden(node, hidden) {
    if (hidden) node.setAttribute('hidden', '');
    else node.removeAttribute('hidden');
  }

  const head = el('tr', {},
    el('th', { scope: 'col', class: 'is-num is-index' }, '#'),
    el('th', { scope: 'col', class: 'is-action' }, 'Action'),
    el('th', { scope: 'col' }, 'Owner'),
    el('th', { scope: 'col' }, 'Effort'),
    el('th', { scope: 'col' }, 'Impact'),
    el('th', { scope: 'col' }, 'When'));
  const table = el('table', { class: 'chat-table chat-action-plan' },
    el('thead', {}, head),
    body);
  paint();
  return el('section', {
    class: 'chat-block chat-block-action-plan',
    'data-block-type': 'action-plan',
    'data-block-id': (block && block.id) || '',
    'aria-label': data.title ? String(data.title) : 'Action plan',
  },
  data.title ? el('h3', { class: 'chat-block-title' }, String(data.title)) : null,
  el('div', { class: 'chat-scroll' }, table),
  more);
}
